<template lang="html">
  <div id="bitacora" class="container-fluid">
    <div id="formulario-top">

      <div class="row">
        <div class="col-sm-2 col-sm-offset-4 col-xs-8 col-xs-offset-2">
          <select-c name="ducto" id="ducto" :options="ductos" placeholder="DUCTO" @changeSelect="setVal($event)"></select-c>
        </div>
        <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <select-c name="concepto" id="concepto" :options="conceptos" placeholder="CONCEPTO" @changeSelect="setVal($event)"></select-c>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-sm-offset-4 col-xs-8 col-xs-offset-2">
          <c-input type="text" name="registro" cid="comentario" val="name" placeholder="(ingrese comentario)" @getVal="comentario = $event" label="Registro (ingrese comentario)"></c-input>
        </div>
      </div>

      <div id="buttons" class="row">
        <div class="col-md-4 col-md-offset-6 col-sm-5 col-sm-offset-4 col-xs-12">
          <button class="btn btn-default text-uppercase waves-effect waves-light">limpiar</button>
          <button class="btn btn-default text-uppercase waves-effect waves-light" @click="postBitacora()" :class="[( comentario ==='' || ducto === '' || concepto === '') ? 'disabled' : '']">guardar</button>
        </div>
      </div>
    </div>
    <div class="row" id="search">
       <div class="col-sm-2 col-sm-offset-1 col-xs-8 col-xs-offset-2">
          <date-picker :date="date" :option="option2" @change="validate($event, 'desde')"></date-picker>
        </div>
        <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <date-picker :date="date" :option="option"  @change="validate($event, 'hasta')"></date-picker>
        </div>
        <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <select-c name="ductoGet" id="ductoGet" :options="ductos" placeholder="DUCTO" @changeSelect="ductoGet = $event"></select-c>
        </div>
        <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <select-c name="conceptoGet" id="conceptoGet" :options="conceptos" placeholder="CONCEPTO" @changeSelect="conceptoGet = $event"></select-c>
        </div>
        <div id="buscar" class="col-sm-3 col-sm-offset-0 col-xs-8 col-xs-offset-2">
           <button class="btn btn-default text-uppercase waves-effect waves-light" @click="searchBitacora()" :class="[(desde === '' || hasta === '' || ductoGet === '' || conceptoGet === '') ? 'disabled' : '']">Buscar</button>
           <a href="" v-show="showEx">
             <json-ex
              :data   = "jsonData"
              :fields = "jsonFields"
              :name   = "`Bitacora-${ductoGet}-${desde}-${hasta}.xls`"
              :meta   = "jsonMeta">
             <i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
            </json-ex>
          </a>
        </div>
    </div>
    <div id="tabla" class="row tabla-bottom">
      <c-table id="bitacora" :data="getBitacora" :names="bitacoraNames" @mapMarker="changeMarkers($event)" modalTarget="#bitacora-modal"></c-table>
    </div>

    <modal name="bitacora" :markerList="list">
      <c-map mcClass="modal" :markerList="list"></c-map>
    </modal>

  </div>
</template>

<script>
import Vue from 'vue'
import toastr from 'toastr'
import selectC from 'reusable/Select'
import cInput from 'reusable/Input'
import cTable from 'reusable/SingleTable'
import Modal from 'reusable/Modal'
import cMap from 'reusable/Map'
import DatePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import JsonEx from 'vue-json-excel'

export default {
  data() {
    return {
      list: 'a',
      jsonData: [],
      jsonFields: {
        section: 'Sección',
        user: 'Usuario',
        fecha: 'Fecha',
        concepto: 'Concepto',
        comment: 'Comentario',
      },
      jsonMeta: [{'key' : 'charset', 'value' : 'utf-8'}],
      bitacoraNames: {
        'f1': {
          name: 'Sección',
          // icon: 'fa-angle-down'
        },
        'f2': {
          name: 'Usuario',
        },
        'f3': {
          name: 'Fecha',
        },
        'f4': {
          name: 'Concepto',
        },
        'f5': {
          name: 'Comentario',
        },
        // 'f6': {
        //   name: 'Alarma asignada',
        // }
      },
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde,
      comentario: '',
      ducto: '',
      concepto: '',
      conceptoGet: '',
      ductoGet: '',
      desde: '',
      hasta: '',
      options: null,
      ductos: [],
      conceptos: [],
      getBitacora: [],
      showEx: false
    }
  },
  watch: {
    list() {
      return this.list
    }
  },
  methods: {
    setVal(e){
      this[e] = document.querySelector(`#${e}`).value
    },
    postBitacora() {
      let user = Vue.ls.get('user')
      this.$store.dispatch('POST_BITACORA', {
        username : user.username,
        id_section : this.ducto,
        id_concept : this.concepto,
        comment : this.comentario,
      }).then(resp => {
         toastr.success('Se a añadido exitosamente tu comentario !')
         this.ducto = ''
         this.concepto = ''
         this.comentario = ''
         document.querySelector('#ducto').value = ''
         document.querySelector('#concepto').value = ''
         document.querySelector('#comentario').value = ''
      }).catch(err => {
        toastr.error('Hubo un error, Favor de volver a intentarlo')
        console.log('Error', err)
      })
    },
    searchBitacora(){
      this.ductoGet = document.querySelector('#ductoGet').value
      this.conceptoGet = document.querySelector('#conceptoGet').value
      if(this.desde === '' || this.hasta === '' || this.ductoGet === '' || this.conceptoGet === '') {
        return
      }
      this.$store.dispatch('LOAD_BITACORA', {
        desde: this.desde,
        hasta: this.hasta,
        concepto: this.conceptoGet,
        ducto: this.ductoGet
      }).then(resp => {
        if(resp.data.length === 0) {
          toastr.error('No se encontró información')
          return
        }
        this.showEx = true
        resp.data.forEach(d => {
          this.getBitacora.push({
            section: d.section_name,
            user: d.user_name,
            fecha: d.date,
            concepto: d.concept_name,
            comment: d.comment
          })
        })
        this.jsonData = this.getBitacora
      })
    },
    changeMarkers(e){
      this.list = e
    },
    validate(e, d) {
      this[d] = e
      let max = this.hasta
      let min = this.desde
      if(max !== '' && (max <= min || min === '')) {
        this.desdeText = 'Este valor debe ser menor'
        this.hastaText = 'Este valor debe ser mayor'
        this.validation = false
      } else {
        this.desdeText = ''
        this.hastaText = ''
        this.validation = true
      }
    },
  },
  mounted() {
    this.$store.dispatch('LOAD_CONCEPTOS')
      .then(resp => {
        resp.data.forEach(con => {
          this.conceptos.push({
            name: con.name,
            value: con.id_journal_concept
          })
        })
      }).catch(err => {
        console.log('Error', err)
      })
    this.$store.dispatch('LOAD_OPS')
      .then(resp => {
        this.ductos = this.$store.getters.GET_OP({
          filteredBy: 'section_name'
        })
      }).catch(err => {
        console.log('Error', err)
      })
  },
  components: {
    selectC,
    cInput,
    cTable,
    Modal,
    cMap,
    DatePicker,
    JsonEx
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';
.container-fluid, .row {
  margin: 0;
  padding: 0;
}

#bitacora {
  background-color: $bg;
  height:100%;
  #formulario-top {
    height: 35vh;
    margin-top: 80px;
    border-bottom: 1px solid $inactive;
    @include celphone{
      height: 45vh;
    }
  }

  #graficas {
    height: 75vh;
  }

  #buttons{
    @include celphone{
      text-align: center;
    }
  }

  .btn-default {
    margin-top: 0;
    background-color: $amarilloC;
    &:hover,
    &:active,
    &:focus {
      background-color: $amarilloO !important;
    }
  }

  #search{
    margin: 15px;
    #buscar {
      @include tablet{
        margin-top: 15px;
      }
    }
  }

  .tabla-bottom{
  height:100vh;
  } 
}
</style>





// WEBPACK FOOTER //
// Bitacora.vue?a54af27e